export function firstLine(text: string) {
  return text.split('\n')[0];
}
